import _styled from "styled-components";
import React from "react";
import { KeyboardRow } from "./KeyboardRow";
import { keyboardSymbols } from "./keyboardSymbols";

var Container = _styled.div.withConfig({
  displayName: "KeyboardFrame__Container",
  componentId: "j14ehx-0"
})(["display:flex;flex-direction:column;padding:8px 8px 4px 0;background-color:#d6d6d6;"]);

export function KeyboardFrame(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$clearOnDelete = _ref.clearOnDelete,
      clearOnDelete = _ref$clearOnDelete === void 0 ? false : _ref$clearOnDelete,
      _ref$disableMinus = _ref.disableMinus,
      disableMinus = _ref$disableMinus === void 0 ? false : _ref$disableMinus;
  return /*#__PURE__*/React.createElement(Container, null, keyboardSymbols.map(function (keyboardRowData, index) {
    return /*#__PURE__*/React.createElement(KeyboardRow, {
      keyRowNamesArray: keyboardRowData,
      value: value,
      onChange: onChange,
      clearOnDelete: clearOnDelete,
      disableMinus: disableMinus,
      key: index
    });
  }));
}